import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import {
  calculateFilledPercent,
  getParentBlockQuantity,
} from "./filledPercentHelpers";

/**
 * AG Grid valueFormatter for copy/paste functionality.
 * Returns the rounded down percentage value.
 *
 * @param params - AG Grid cell params
 * @returns Formatted string for copy/paste
 */
export function filledPercentValueFormatter(params: any): string {
  if (!params.data) {
    return "";
  }

  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;

  const fillQuantity = params.data?.fillSize;
  const fillPrice = params.data?.fillPrice;
  const blockId = params.data?.blockId;

  let blockQuantity: number | null = null;

  if (esid && blockId !== undefined) {
    blockQuantity = getParentBlockQuantity(esid, blockId);
  }

  if (blockQuantity === null && params.data?.parentQuantity) {
    blockQuantity = params.data.parentQuantity;
  }

  const percent = calculateFilledPercent(
    fillQuantity,
    blockQuantity ?? 0,
    fillPrice,
  );
  const displayPercent = Math.round(percent);

  return `${displayPercent} `;
}
